/* Colorway swatch groups linked by shared "sg-" product tags.

   Siblings come from the Section Rendering API (swatch-group-json section):
     primary  /collections/all/<tag>?section_id=swatch-group-json
              (collection rendering - always current prices / stock)
     fallback /search?q=<tag>&type=product&section_id=swatch-group-json
              (search index can lag minutes behind price/tag edits)
   Cached per tab for CACHE_TTL only. Bump CACHE_PREFIX to invalidate.

   Swatch visual, in priority order:
     1. flat colour chip   (solid colourways - no image needed)
     2. fabric close-up    (patterns - theme asset)
     3. product photo      (fallback: groups that are NOT colourways,
                            e.g. graphic tees / fit variants)
   Edit snippets/bv-colorway-map.liquid to change any of this.

   On product CARDS a swatch swaps the card in place (image, title, price +
   sale state, badge, link, size pills) instead of navigating.

   The card's server-rendered state for its ORIGINAL product is snapshotted
   once and restored from that snapshot - never rebuilt from fetched JSON -
   so sale pricing can't be overwritten by stale or lagging data. */
(function () {
  'use strict';

  var CACHE_PREFIX = 'bvsg4:';
  var CACHE_TTL = 5 * 60 * 1000;
  var CARD_MAX_VISIBLE = 6;
  var memoryCache = {};
  var MAP = null;
  var BADGE = null;

  function map() {
    if (MAP) return MAP;
    MAP = { solids: {}, fabrics: {} };
    try {
      var el = document.getElementById('bv-colorway-map');
      if (el) {
        var parsed = JSON.parse(el.textContent);
        MAP.solids = parsed.solids || {};
        MAP.fabrics = parsed.fabrics || {};
      }
    } catch (e) { /* fall back to photos */ }
    return MAP;
  }

  function key(s) {
    return String(s || '').toUpperCase().replace(/\s+/g, ' ').trim();
  }

  /* ---- data ---- */
  function parseGroup(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var dataEl = tpl.content.querySelector('[data-swatch-group-data]');
    if (!dataEl) return [];
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return []; }
    var slim = (data.products || []).filter(function (p) { return p.handle; });
    slim.sort(function (a, b) { return a.title.localeCompare(b.title); });
    return slim;
  }

  function fetchText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    });
  }

  function fetchGroup(tag) {
    if (memoryCache[tag]) return memoryCache[tag];
    var cached = null;
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + tag);
      if (raw) {
        var entry = JSON.parse(raw);
        if (entry && entry.t && (Date.now() - entry.t) < CACHE_TTL && entry.d && entry.d.length) cached = entry.d;
      }
    } catch (e) {}
    if (cached) {
      memoryCache[tag] = Promise.resolve(cached);
      return memoryCache[tag];
    }
    var primary = '/collections/all/' + encodeURIComponent(tag) + '?section_id=swatch-group-json';
    var fallback = '/search?q=' + encodeURIComponent(tag) + '&type=product&section_id=swatch-group-json';
    memoryCache[tag] = fetchText(primary).then(parseGroup).catch(function () { return []; })
      .then(function (list) {
        if (list.length) return list;
        return fetchText(fallback).then(parseGroup);
      })
      .then(function (list) {
        if (list.length) {
          try { sessionStorage.setItem(CACHE_PREFIX + tag, JSON.stringify({ t: Date.now(), d: list })); } catch (e) {}
        }
        return list;
      });
    return memoryCache[tag];
  }

  function colorwayName(p) {
    if (p.colorway) return p.colorway;
    var parts = String(p.title || '').split(/\s+IN\s+/i);
    return parts.length > 1 ? parts[parts.length - 1] : p.title;
  }

  function makeSwatch(p, isCurrent) {
    var name = colorwayName(p);
    var k = key(name);
    var m = map();
    var a = document.createElement('a');
    a.className = 'bv-swatch' + (isCurrent ? ' is-current' : '');
    a.href = p.url || '/products/' + p.handle;
    a.setAttribute('aria-label', name);
    a.title = name;
    if (isCurrent) a.setAttribute('aria-current', 'page');

    if (m.solids[k]) {
      a.classList.add('bv-swatch--color');
      var chip = document.createElement('span');
      chip.className = 'bv-swatch__chip';
      chip.style.backgroundColor = m.solids[k];
      a.appendChild(chip);
    } else if (m.fabrics[k]) {
      a.classList.add('bv-swatch--fabric');
      var fab = document.createElement('img');
      fab.src = m.fabrics[k];
      fab.alt = name;
      fab.loading = 'eager';
      a.appendChild(fab);
    } else {
      var img = document.createElement('img');
      img.src = p.image || '';
      img.alt = name;
      img.loading = 'lazy';
      a.appendChild(img);
    }
    return a;
  }

  /* ---- snapshot / restore the server-rendered card ---- */
  function setAttr(el, name, val) {
    if (val === null || val === undefined) el.removeAttribute(name);
    else el.setAttribute(name, val);
  }

  function snapshotCard(card, handle) {
    if (card.__bvSnap) return card.__bvSnap;
    var snap = { handle: handle, imgs: [], heads: [], links: [], price: null, badges: [], pills: null };
    card.querySelectorAll('.card__media img, .card__inner img').forEach(function (im) {
      snap.imgs.push({ el: im, src: im.getAttribute('src'), srcset: im.getAttribute('srcset'),
                       sizes: im.getAttribute('sizes'), alt: im.getAttribute('alt') });
    });
    card.querySelectorAll('.card__heading').forEach(function (h) {
      var a = h.querySelector('a[href]');
      snap.heads.push({ el: h, a: a, text: a ? a.textContent : h.textContent, href: a ? a.getAttribute('href') : null });
    });
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!a.classList.contains('bv-swatch')) snap.links.push({ el: a, href: a.getAttribute('href') });
    });
    var price = card.querySelector('.price');
    if (price) snap.price = { el: price, html: price.innerHTML, cls: price.className };
    card.querySelectorAll('.card__badge').forEach(function (b) { snap.badges.push({ el: b, html: b.innerHTML }); });
    var pills = card.querySelector('.bv-size-pills');
    if (pills) snap.pills = { el: pills, html: pills.innerHTML, url: pills.getAttribute('data-product-url'), display: pills.style.display };
    card.__bvSnap = snap;
    return snap;
  }

  function restoreCard(card) {
    var s = card.__bvSnap;
    if (!s) return;
    s.imgs.forEach(function (i) {
      setAttr(i.el, 'srcset', i.srcset); setAttr(i.el, 'sizes', i.sizes);
      setAttr(i.el, 'src', i.src); setAttr(i.el, 'alt', i.alt);
    });
    s.heads.forEach(function (h) {
      if (h.a) { h.a.textContent = h.text; setAttr(h.a, 'href', h.href); }
      else h.el.textContent = h.text;
    });
    s.links.forEach(function (l) { setAttr(l.el, 'href', l.href); });
    if (s.price) { s.price.el.innerHTML = s.price.html; s.price.el.className = s.price.cls; }
    s.badges.forEach(function (b) { b.el.innerHTML = b.html; });
    if (s.pills) {
      s.pills.el.innerHTML = s.pills.html;
      setAttr(s.pills.el, 'data-product-url', s.pills.url);
      s.pills.el.style.display = s.pills.display || '';
    }
  }

  /* learn the theme's sale badge markup from any card on the page */
  function saleBadge() {
    if (BADGE) return BADGE;
    var found = null;
    document.querySelectorAll('.card__badge .badge').forEach(function (b) {
      if (!found && /sale/i.test(b.textContent)) found = b;
    });
    BADGE = found ? { cls: found.className, text: found.textContent.trim() }
                  : { cls: 'badge badge--bottom-left color-scheme-4', text: 'Sale' };
    return BADGE;
  }

  /* ---- swap a product card to another colourway, no page load ---- */
  function swapCard(card, p) {
    if (!card || !p) return;
    if (card.__bvSnap && p.handle === card.__bvSnap.handle) { restoreCard(card); return; }

    /* Dawn cards render the image AND heading twice (inner + content),
       so update every instance, not just the first. */
    if (p.card_image) {
      card.querySelectorAll('.card__media img, .card__inner img').forEach(function (im) {
        im.removeAttribute('srcset');
        im.removeAttribute('sizes');
        im.src = p.card_image;
        if (p.card_image_2x) im.srcset = p.card_image + ' 1x, ' + p.card_image_2x + ' 2x';
        im.alt = p.title || '';
      });
    }

    card.querySelectorAll('.card__heading').forEach(function (h) {
      var link = h.querySelector('a[href]');
      if (link) { link.textContent = p.title; link.href = p.url; }
      else h.textContent = p.title;
    });

    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!a.classList.contains('bv-swatch')) a.href = p.url;
    });

    var onSale = !!(p.on_sale && p.compare_at);

    /* price: Dawn renders .price__regular (shown when not on sale) and
       .price__sale (<s>compare-at</s> + sale price, shown when on sale) */
    var price = card.querySelector('.price');
    if (price && p.price) {
      var regs = price.querySelectorAll('.price__regular .price-item--regular');
      var strikes = price.querySelectorAll('.price__sale .price-item--regular');
      var sales = price.querySelectorAll('.price-item--sale');
      if (onSale && !strikes.length && sales.length) {
        var wrap = document.createElement('span');
        var s = document.createElement('s');
        s.className = 'price-item price-item--regular';
        wrap.appendChild(s);
        sales[0].parentNode.insertBefore(wrap, sales[0]);
        strikes = price.querySelectorAll('.price__sale .price-item--regular');
      }
      regs.forEach(function (n) { n.textContent = p.price; });
      strikes.forEach(function (n) { n.textContent = onSale ? p.compare_at : ''; });
      sales.forEach(function (n) { n.textContent = p.price; });
      price.classList.toggle('price--on-sale', onSale);
      price.classList.remove('price--sold-out');
      if (!regs.length && !sales.length) price.textContent = p.price;
    }

    /* sale badge on the image */
    card.querySelectorAll('.card__badge').forEach(function (b) {
      if (onSale) {
        var tpl = saleBadge();
        var existing = b.querySelector('.badge');
        if (!existing) {
          existing = document.createElement('span');
          b.appendChild(existing);
        }
        existing.className = tpl.cls;
        existing.textContent = tpl.text;
      } else {
        b.innerHTML = '';
      }
    });

    /* size pills must add THIS product's variants, not the original's */
    var pills = card.querySelector('.bv-size-pills');
    if (pills) {
      if (p.url) pills.setAttribute('data-product-url', p.url);
      if (p.size_option && p.variants && p.variants.length) {
        pills.innerHTML = '';
        p.variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bv-size-pill' + (v.available ? '' : ' is-sold-out');
          btn.setAttribute('data-variant-id', String(v.id));
          btn.setAttribute('aria-label', 'Add size ' + v.size + ' to cart');
          if (!v.available) btn.disabled = true;
          btn.textContent = v.size;
          pills.appendChild(btn);
        });
        pills.style.display = '';
      } else {
        pills.style.display = 'none';
      }
    }
  }

  function render(container, products) {
    if (!products || products.length < 2) return;
    var itemsEl = container.querySelector('[data-bv-swatch-items]');
    if (!itemsEl) return;

    var currentHandle = container.getAttribute('data-current-handle') || '';
    var isCard = container.classList.contains('bv-swatch-group--card');
    var card = isCard ? container.closest('.card-wrapper') : null;
    if (card) snapshotCard(card, currentHandle);

    var visible = products;
    var overflow = 0;
    if (isCard && products.length > CARD_MAX_VISIBLE) {
      visible = products.slice(0, CARD_MAX_VISIBLE - 1);
      var hasCurrent = visible.some(function (p) { return p.handle === currentHandle; });
      if (!hasCurrent) {
        var cur = products.filter(function (p) { return p.handle === currentHandle; })[0];
        if (cur) visible[visible.length - 1] = cur;
      }
      overflow = products.length - visible.length;
    }

    var frag = document.createDocumentFragment();
    visible.forEach(function (p) {
      var sw = makeSwatch(p, p.handle === currentHandle);

      if (isCard && card) {
        /* browse colourways in place - a click should not cost a page load */
        sw.addEventListener('click', function (ev) {
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
          ev.preventDefault();
          ev.stopPropagation();
          swapCard(card, p);
          var all = itemsEl.querySelectorAll('.bv-swatch');
          for (var i = 0; i < all.length; i++) {
            all[i].classList.remove('is-current');
            all[i].removeAttribute('aria-current');
          }
          sw.classList.add('is-current');
          sw.setAttribute('aria-current', 'true');
          container.setAttribute('data-current-handle', p.handle);
        });
        /* hovering previews the colourway too - zero clicks */
        sw.addEventListener('mouseenter', function () {
          swapCard(card, p);
        });
      }
      frag.appendChild(sw);
    });

    if (overflow > 0) {
      var more = document.createElement('a');
      more.className = 'bv-swatch bv-swatch--more';
      more.href = (products.filter(function (p) { return p.handle === currentHandle; })[0] || products[0]).url;
      more.setAttribute('aria-label', overflow + ' more styles');
      more.textContent = '+' + overflow;
      frag.appendChild(more);
    }

    itemsEl.innerHTML = '';
    itemsEl.appendChild(frag);
    container.hidden = false;

    /* restore the selected colourway when the pointer leaves the card */
    if (isCard && card && !card.hasAttribute('data-bv-restore')) {
      card.setAttribute('data-bv-restore', '1');
      card.addEventListener('mouseleave', function () {
        var active = container.getAttribute('data-current-handle');
        var target = products.filter(function (p) { return p.handle === active; })[0];
        if (target) swapCard(card, target);
      });
    }
  }

  function init(container) {
    var tag = container.getAttribute('data-bv-swatch-group');
    if (!tag) return;
    fetchGroup(tag).then(function (products) {
      render(container, products);
    }).catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-bv-swatch-group]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* re-init when a section re-renders */
  document.addEventListener('shopify:section:load', boot);
})();

/* v4 */
